import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { omit, get } from 'lodash-es'

import { ReduxFormSimpleFieldComponent } from '..'

const TextareaAutoResizeComponent = (props) => {
  const { input, initialHeight, customInputProps, maxHeight } = props

  const heightRef = useRef(initialHeight)
  const textarea = useRef(null)

  useEffect(() => {
    if (input.value === '') {
      heightRef.current = initialHeight
    }
  }, [input.value, initialHeight])

  const getPropsForSimpleField = () => {
    const propsToOmit = ['input', 'initialHeight', 'maxHeight']
    return omit(props, propsToOmit)
  }

  const resizeTextarea = () => {
    const height = heightRef.current
    const { scrollHeight } = textarea.current
    const scrollHeightPx = `${scrollHeight}px`
    const noInput = input.value === ''
    const heightNeedsSyncing = scrollHeightPx !== height
    const shouldChangeHeight = noInput || heightNeedsSyncing
    const newHeight = noInput ? initialHeight : scrollHeightPx

    if (shouldChangeHeight) {
      heightRef.current = newHeight
    }
  }

  const onChange = (e) => {
    resizeTextarea()
    input.onChange(e)
  }

  return (
    <ReduxFormSimpleFieldComponent
      {...getPropsForSimpleField()}
      input={{ ...input, onChange }}
      elementRef={(element) => {
        textarea.current = element
        return element
      }}
      customInputProps={{
        ...customInputProps,
        style: {
          height: heightRef.current,
          maxHeight,
          ...get(customInputProps, 'style', {}),
        },
      }}
    />
  )
}

TextareaAutoResizeComponent.propTypes = {
  initialHeight: PropTypes.string,
  maxHeight: PropTypes.string,
  input: PropTypes.object,
  customInputProps: PropTypes.object,
}

TextareaAutoResizeComponent.defaultProps = {
  initialHeight: 'auto',
  maxHeight: '100',
  customInputProps: {},
}

export default TextareaAutoResizeComponent
